<template>
  <div>
    <h4>{{ $t("room.illumination.rugl.title") }}</h4>
    <v-row class="mx-0 my-3 d-flex justify-space-between align-baseline">
      <span class="caption black20">
        {{ $t("tests.illumination.measurement_card.required") }}
      </span>
      <span class="body2">{{ requiredRuglLabel }}</span>
    </v-row>
    <v-row class="mx-0 my-3 d-flex justify-space-between align-baseline">
      <span class="caption black20">
        {{ $t("tests.illumination.measurement_card.measured") }}
      </span>
      <span class="body2">{{ measuredRuglLabel }}</span>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "rugl-card-info",
  props: ["test"],
  computed: {
    requiredRuglLabel() {
      const { required_rugl } = this.test;
      if (Number.isInteger(required_rugl) && required_rugl >= 0) {
        return required_rugl;
      }
      return "-";
    },
    measuredRuglLabel() {
      const { measured_rugl } = this.test;
      if (Number.isInteger(measured_rugl) && measured_rugl >= 0) {
        return measured_rugl;
      }
      return "-";
    },
  },
};
</script>

<style scoped>
.black20 {
  color: #333333;
  font-weight: 500;
}
</style>
